/* Popear Vision — scripts du thème (sans dépendance) */
(() => {
  'use strict';

  const T = window.theme || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Argent ---------- */
  function formatMoney(cents, format = T.moneyFormat || '{{amount_with_comma_separator}} €') {
    const value = Number(cents) / 100;
    const fmt = (n, decimals, thousands, decimal) => {
      const [i, d] = n.toFixed(decimals).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (d ? decimal + d : '');
    };
    return String(format).replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(value, 2, ' ', ',');
        default: return fmt(value, 2, '.', ',');
      }
    });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------- Panier (API AJAX) ---------- */
  const Cart = {
    sections() {
      return $('cart-drawer') ? 'cart-drawer' : undefined;
    },
    async post(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign({ sections: this.sections(), sections_url: window.location.pathname }, body)),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || data.message || T.strings.error);
      return data;
    },
    async add(items) {
      const data = await this.post(T.routes.cartAdd + '.js', { items });
      this.render(data.sections);
      return data;
    },
    async change(line, quantity) {
      const data = await this.post(T.routes.cartChange + '.js', { line, quantity });
      this.render(data.sections);
      return data;
    },
    render(sections) {
      const drawer = $('cart-drawer');
      if (!sections || !sections['cart-drawer'] || !drawer) {
        fetch(T.routes.cart + '.js').then((r) => r.json()).then((c) => setCount(c.item_count)).catch(() => {});
        return;
      }
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = $('[data-cart-inner]', doc);
      const current = $('[data-cart-inner]', drawer);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      const count = $('cart-drawer', doc);
      if (count) setCount(Number(count.dataset.count || 0));
    },
  };

  function setCount(n) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.hidden = n === 0;
      el.style.animation = 'none';
      void el.offsetWidth;
      el.style.animation = '';
    });
  }

  function afterAdd() {
    const drawer = $('cart-drawer');
    if (T.cartType === 'drawer' && drawer) drawer.open();
    else window.location.href = T.routes.cart;
  }

  /* ---------- Verrouillage du défilement ---------- */
  let locks = 0;
  function lockScroll(on) {
    locks = Math.max(0, locks + (on ? 1 : -1));
    document.documentElement.style.overflow = locks ? 'hidden' : '';
  }

  /* ---------- En-tête ---------- */
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.onScroll = () => this.classList.toggle('is-scrolled', window.scrollY > 24);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }
  }

  class MenuDrawer extends HTMLElement {
    connectedCallback() {
      this.openers = $$('[data-menu-open]');
      this.openers.forEach((b) => b.addEventListener('click', () => this.open()));
      $$('[data-menu-close]', this).forEach((b) => b.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => e.key === 'Escape' && this.close());
    }
    open() {
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      this.openers.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      lockScroll(true);
      setTimeout(() => { const f = $('a, button', $('.mdrawer__panel', this)); f && f.focus(); }, 350);
    }
    close() {
      if (this.hidden) return;
      this.classList.remove('is-open');
      this.openers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      lockScroll(false);
      setTimeout(() => { this.hidden = true; }, 500);
      this.openers[0] && this.openers[0].focus();
    }
  }

  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.items = $$('.announce__item', this);
      if (this.items.length < 2 || reduced) return;
      this.i = 0;
      this.timer = setInterval(() => this.next(), (Number(this.dataset.speed) || 4) * 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    next() {
      const cur = this.items[this.i];
      this.i = (this.i + 1) % this.items.length;
      const nxt = this.items[this.i];
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      nxt.classList.remove('is-leaving');
      nxt.classList.add('is-active');
      setTimeout(() => cur.classList.remove('is-leaving'), 700);
    }
  }

  /* ---------- Panier tiroir ---------- */
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = $('.cdrawer__panel', this);
      document.addEventListener('click', (e) => {
        const opener = e.target.closest('[data-cart-open]');
        if (opener && T.cartType === 'drawer') {
          e.preventDefault();
          this.open();
        }
      });
      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-cart-qty]')) {
          const line = Number(e.target.closest('[data-line]').dataset.line);
          this.update(line, Math.max(0, parseInt(e.target.value, 10) || 0));
        }
      });
      document.addEventListener('keydown', (e) => e.key === 'Escape' && this.close());
    }
    async onClick(e) {
      if (e.target.closest('[data-cart-close]')) return this.close();
      const remove = e.target.closest('[data-cart-remove]');
      if (remove) return this.update(Number(remove.dataset.cartRemove), 0);
      const add = e.target.closest('[data-cart-add]');
      if (add) {
        add.classList.add('is-loading');
        this.classList.add('is-busy');
        try {
          await Cart.add([{ id: Number(add.dataset.cartAdd), quantity: 1 }]);
        } catch (err) {
          toast(err.message);
        }
        this.classList.remove('is-busy');
      }
    }
    async update(line, qty) {
      this.classList.add('is-busy');
      try {
        await Cart.change(line, qty);
      } catch (err) {
        toast(err.message);
      }
      this.classList.remove('is-busy');
    }
    open() {
      if (this.classList.contains('is-open')) return;
      this.lastFocus = document.activeElement;
      this.classList.add('is-open');
      lockScroll(true);
      setTimeout(() => this.panel.focus(), 60);
    }
    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      lockScroll(false);
      this.lastFocus && this.lastFocus.focus && this.lastFocus.focus();
    }
  }

  /* ---------- Quantité ---------- */
  class QtyInput extends HTMLElement {
    connectedCallback() {
      this.input = $('input', this);
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-step]');
        if (!btn) return;
        const min = Number(this.input.min || 0);
        const v = Math.max(min, (parseInt(this.input.value, 10) || 0) + Number(btn.dataset.step));
        if (String(v) === this.input.value) return;
        this.input.value = v;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  /* ---------- Ajout rapide (cartes produit) ---------- */
  class QuickAdd extends HTMLElement {
    connectedCallback() {
      this.form = $('form', this);
      this.idInput = $('[data-variant-input]', this);
      $$('.dot', this).forEach((dot) =>
        dot.addEventListener('click', () => {
          $$('.dot', this).forEach((d) => {
            d.classList.toggle('is-active', d === dot);
            d.setAttribute('aria-checked', String(d === dot));
          });
          this.idInput.value = dot.dataset.variantId;
          const price = $('[data-price-current]', this.closest('.pcard'));
          if (price && dot.dataset.price) price.innerHTML = dot.dataset.price;
        }),
      );
      this.form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = $('button[type="submit"]', this.form);
        btn.classList.add('is-loading');
        btn.disabled = true;
        try {
          await Cart.add([{ id: Number(this.idInput.value), quantity: 1 }]);
          afterAdd();
        } catch (err) {
          toast(err.message);
        }
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
    }
  }

  /* ---------- Fiche produit ---------- */
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      try {
        this.product = JSON.parse($('[data-product-json]', this).textContent);
      } catch (e) {
        return;
      }
      this.form = document.getElementById(this.dataset.formId);
      this.idInput = this.form && $('[data-variant-input]', this.form);
      this.lowStock = Number(this.dataset.lowStock || 10);
      this.variant = this.product.variants.find((v) => this.idInput && v.id === Number(this.idInput.value)) || this.product.variants[0];
      this.addEventListener('change', (e) => {
        if (e.target.closest('variant-picker')) this.onOptionChange();
      });
      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.updateAvailability();
    }

    selectedOptions() {
      return $$('.vpicker__group', this).map((g) => {
        const checked = $('input:checked', g);
        return checked ? checked.value : null;
      });
    }

    onOptionChange() {
      const opts = this.selectedOptions();
      const v = this.product.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      $$('.vpicker__group', this).forEach((g, i) => {
        const label = $('[data-option-label]', g);
        if (label) label.textContent = opts[i];
      });
      this.variant = v || null;
      this.updateAvailability();
      this.render();
      if (!v) return;
      if (this.idInput) this.idInput.value = v.id;
      if (this.hasAttribute('data-update-url')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      const color = colorKey(v.options);
      document.dispatchEvent(new CustomEvent('product:variant', { detail: { productId: this.product.id, variant: v, color, section: this.dataset.section } }));
    }

    updateAvailability() {
      const groups = $$('.vpicker__group', this);
      const opts = this.selectedOptions();
      groups.forEach((g, gi) => {
        $$('input', g).forEach((input) => {
          const ok = this.product.variants.some(
            (v) => v.available && v.options[gi] === input.value && v.options.every((o, oi) => oi === gi || o === opts[oi] || groups.length === 1),
          );
          input.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    render() {
      const v = this.variant;
      const priceEl = $('[data-price]', this);
      if (priceEl && v) {
        const onSale = v.compare_at_price > v.price;
        $('[data-price-current]', priceEl).textContent = formatMoney(v.price);
        const cmp = $('[data-price-compare]', priceEl);
        if (cmp) {
          cmp.hidden = !onSale;
          cmp.textContent = onSale ? formatMoney(v.compare_at_price) : '';
        }
        const badge = $('[data-price-badge]', priceEl);
        if (badge) {
          badge.hidden = !onSale;
          badge.textContent = onSale ? `${T.strings.save} ${formatMoney(v.compare_at_price - v.price)}` : '';
        }
        priceEl.classList.toggle('price--sale', onSale);
      }
      const atc = this.form && $('[data-atc]', this.form);
      if (atc) {
        atc.disabled = !v || !v.available;
        $('[data-atc-label]', atc).textContent = !v ? T.strings.unavailable : v.available ? T.strings.addToCart : T.strings.soldOut;
        const p = $('[data-atc-price]', atc);
        if (p && v) p.textContent = formatMoney(v.price);
      }
      const stock = $('[data-stock]', this);
      if (stock) {
        const text = $('[data-stock-text]', stock);
        const low = v && v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= this.lowStock;
        stock.classList.toggle('stock--low', !!low);
        stock.classList.toggle('stock--out', !v || !v.available);
        text.textContent = !v ? T.strings.unavailable : !v.available ? T.strings.soldOut : low ? T.strings.stockLow.replace('[count]', v.inventory_quantity) : T.strings.inStock;
      }
    }

    async onSubmit(e) {
      e.preventDefault();
      if (!this.variant || !this.variant.available) return;
      const btn = $('[data-atc]', this.form);
      const err = $('[data-form-error]', this.form);
      const qtyInput = this.form.elements.quantity;
      const quantity = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
      const items = [{ id: this.variant.id, quantity }];
      $$('[data-upsell]:checked', this).forEach((u) => items.push({ id: Number(u.value), quantity: 1 }));
      btn.classList.add('is-loading');
      btn.disabled = true;
      if (err) err.hidden = true;
      try {
        await Cart.add(items);
        document.dispatchEvent(new CustomEvent('product:added', { detail: { productId: this.product.id } }));
        afterAdd();
      } catch (ex) {
        if (err) {
          err.textContent = ex.message;
          err.hidden = false;
        } else toast(ex.message);
      }
      btn.classList.remove('is-loading');
      btn.disabled = !this.variant.available;
    }
  }

  function colorKey(values) {
    const s = values.join(' ').toLowerCase();
    if (/blanc|white/.test(s)) return 'blanc';
    if (/noir|black|graphite/.test(s)) return 'noir';
    return null;
  }

  class VariantPicker extends HTMLElement {}

  /* ---------- Galerie ---------- */
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-track]', this);
      this.slides = $$('.gallery__slide', this);
      this.thumbs = $$('[data-thumb]', this);
      this.dots = $$('.gallery__dot', this);
      this.index = 0;
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
      const prev = $('[data-prev]', this);
      const next = $('[data-next]', this);
      prev && prev.addEventListener('click', () => this.go(this.index - 1));
      next && next.addEventListener('click', () => this.go(this.index + 1));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.sync());
      }, { passive: true });
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.go(this.index + 1);
        if (e.key === 'ArrowLeft') this.go(this.index - 1);
      });
      this.onVariant = (e) => {
        const d = e.detail;
        if (String(d.productId) !== this.dataset.productId || d.section !== this.dataset.section) return;
        if (this.slides[this.index] && this.slides[this.index].dataset.mediaId === '3d') return; // on reste sur la 3D qui change de couleur
        if (d.variant.featured_media) this.goToMedia(d.variant.featured_media);
      };
      document.addEventListener('product:variant', this.onVariant);
      if (!reduced) {
        const first = this.slides[0] && $('video', this.slides[0]);
        if (first) {
          first.muted = true;
          first.play().catch(() => {});
        }
      }
      const start = $('[data-start-media]', this);
      if (start && !$('.gallery__slide--3d', this)) {
        const i = this.slides.findIndex((s) => s.dataset.mediaId === start.dataset.startMedia);
        if (i > 0) requestAnimationFrame(() => this.go(i, 'auto'));
      }
    }
    disconnectedCallback() {
      document.removeEventListener('product:variant', this.onVariant);
    }
    goToMedia(id) {
      const i = this.slides.findIndex((s) => s.dataset.mediaId === String(id));
      if (i >= 0) this.go(i);
    }
    go(i, behavior = 'smooth') {
      const n = this.slides.length;
      if (!n) return;
      i = (i + n) % n;
      this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: reduced ? 'auto' : behavior });
      this.setActive(i);
    }
    sync() {
      const i = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
      if (i !== this.index) this.setActive(i);
    }
    setActive(i) {
      this.index = i;
      this.slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      this.thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      this.dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      const t = this.thumbs[i];
      if (t) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      this.slides.forEach((s, k) => {
        $$('video', s).forEach((v) => {
          if (k === i && !reduced) {
            v.muted = true;
            v.play().catch(() => {});
          } else v.pause();
        });
      });
    }
  }

  /* ---------- Barre d'achat flottante ---------- */
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.info = this.form.closest('product-info');
      this.atc = $('[data-atc]', this.form);
      this.btn = $('[data-satc-btn]', this);
      this.btn.addEventListener('click', () => {
        if (this.form.requestSubmit) this.form.requestSubmit();
        else this.form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
      $$('[data-satc-value]', this).forEach((dot) =>
        dot.addEventListener('click', () => {
          const input = this.info && $$('variant-picker input', this.info).find((x) => x.value === dot.dataset.satcValue);
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }),
      );
      this.onVariant = (e) => {
        if (!this.info || e.detail.section !== this.info.dataset.section) return;
        const v = e.detail.variant;
        $('[data-satc-price]', this).textContent = formatMoney(v.price);
        const vt = $('[data-satc-variant]', this);
        if (vt) vt.textContent = v.title;
        this.btn.disabled = !v.available;
        $('[data-satc-label]', this).textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
        $$('[data-satc-value]', this).forEach((d) => d.classList.toggle('is-active', v.options.includes(d.dataset.satcValue)));
        const img = $('[data-satc-img]', this);
        if (img && v.image) {
          img.src = v.image;
          img.removeAttribute('srcset');
        }
      };
      document.addEventListener('product:variant', this.onVariant);
      const footer = $('.ftr');
      this.footerVisible = false;
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.target === this.atc) this.atcPassed = !en.isIntersecting && en.boundingClientRect.top < 0;
          else this.footerVisible = en.isIntersecting;
        });
        const show = this.atcPassed && !this.footerVisible;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', String(!show));
        $$('button', this).forEach((b) => (b.tabIndex = show ? 0 : -1));
      });
      this.atc && this.io.observe(this.atc);
      footer && this.io.observe(footer);
    }
    disconnectedCallback() {
      this.io && this.io.disconnect();
      document.removeEventListener('product:variant', this.onVariant);
    }
  }

  /* ---------- Estimation de livraison ---------- */
  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      const add = (d, n) => {
        const r = new Date(d);
        let left = n;
        while (left > 0) {
          r.setDate(r.getDate() + 1);
          const day = r.getDay();
          if (day !== 0 && day !== 6) left--;
        }
        return r;
      };
      const fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'fr', { weekday: 'short', day: 'numeric', month: 'short' });
      const now = new Date();
      const min = Number(this.dataset.min || (T.delivery && T.delivery.min) || 5);
      const max = Math.max(min, Number(this.dataset.max || (T.delivery && T.delivery.max) || 10));
      $('[data-from]', this).textContent = fmt.format(add(now, min));
      $('[data-to]', this).textContent = fmt.format(add(now, max));
    }
  }

  /* ---------- Recommandations ---------- */
  class ProductRecs extends HTMLElement {
    connectedCallback() {
      if (this.children.length || !this.dataset.url) return;
      const io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        fetch(this.dataset.url)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const el = $('product-recs', doc);
            if (el && el.innerHTML.trim()) {
              this.innerHTML = el.innerHTML;
              initReveal(this);
              initTilt(this);
            }
          })
          .catch(() => {});
      }, { rootMargin: '400px' });
      io.observe(this);
    }
  }

  /* ---------- Visionneuse 3D ---------- */
  let pvModule;
  function loadPv() {
    if (!pvModule) pvModule = import(T.pv3dSrc);
    return pvModule;
  }
  function canUse3d() {
    if (!T.enable3d || !T.pv3dSrc) return false;
    const c = navigator.connection;
    if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return false;
    try {
      const cv = document.createElement('canvas');
      return !!(cv.getContext('webgl2') || cv.getContext('webgl'));
    } catch (e) {
      return false;
    }
  }

  class Pv3d extends HTMLElement {
    connectedCallback() {
      this.stage = $('.pv3d__stage', this);
      this.color = this.dataset.color || 'noir';
      this.onColor = (e) => {
        const d = e.detail;
        if (!d.color) return;
        if (this.dataset.productId && String(d.productId) !== this.dataset.productId) return;
        if (!this.dataset.productId && !d.global) return;
        this.setColor(d.color);
      };
      document.addEventListener('product:variant', this.onColor);
      this.addEventListener('pointerdown', () => this.classList.add('is-touched'), { once: true });
      if (!canUse3d()) return;
      const start = () => {
        if (this.started) return;
        this.started = true;
        loadPv()
          .then((m) => {
            if (!this.isConnected) return;
            this.viewer = new m.Popvision3D(this.stage, {
              color: this.color,
              mode: this.dataset.mode || 'free',
              pose: this.dataset.pose || 'hero',
              interactive: !this.hasAttribute('data-static'),
              printWhite: T.pvPrintWhite || '',
              printGreen: T.pvPrintGreen || '',
            });
            if (this.pendingProgress != null) this.viewer.setProgress(this.pendingProgress);
            requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-ready')));
            this.dispatchEvent(new CustomEvent('pv3d:ready', { bubbles: true }));
          })
          .catch(() => {});
      };
      const eager = this.closest('.hero');
      if (eager) {
        const go = () => (window.requestIdleCallback ? requestIdleCallback(start, { timeout: 1500 }) : setTimeout(start, 300));
        if (document.readyState === 'complete') go();
        else window.addEventListener('load', go, { once: true });
      }
      this.io = new IntersectionObserver((entries) => entries[0].isIntersecting && start(), { rootMargin: '300px' });
      this.io.observe(this);
    }
    disconnectedCallback() {
      document.removeEventListener('product:variant', this.onColor);
      this.io && this.io.disconnect();
      this.viewer && this.viewer.destroy();
    }
    setColor(c) {
      this.color = c;
      this.dataset.color = c;
      this.viewer && this.viewer.setColor(c);
    }
    setProgress(p) {
      this.pendingProgress = p;
      this.viewer && this.viewer.setProgress(p);
    }
  }

  /* Sélecteur de coloris du hero */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-pv-color]');
    if (!btn) return;
    const scope = btn.closest('section') || document;
    $$('[data-pv-color]', scope).forEach((b) => {
      b.classList.toggle('is-active', b === btn);
      b.setAttribute('aria-checked', String(b === btn));
    });
    $$('pv-3d', scope).forEach((el) => el.setColor(btn.dataset.pvColor));
  });

  /* ---------- Histoire 3D au défilement ---------- */
  class Story3d extends HTMLElement {
    connectedCallback() {
      this.steps = $$('.story__step', this);
      this.viewer = $('pv-3d', this);
      this.counter = $('[data-story-index]', this);
      this.n = Math.max(1, this.steps.length);
      this.active = -1;
      this.update = this.update.bind(this);
      scrollFx.add(this, this.update);
    }
    disconnectedCallback() {
      scrollFx.remove(this);
    }
    update() {
      const r = this.getBoundingClientRect();
      const total = r.height - window.innerHeight;
      const p = clamp(-r.top / Math.max(1, total));
      this.style.setProperty('--sp', p.toFixed(4));
      const idx = Math.min(this.n - 1, Math.floor(p * this.n));
      if (idx !== this.active) {
        this.active = idx;
        this.steps.forEach((s, i) => {
          s.classList.toggle('is-active', i === idx);
          s.classList.toggle('is-past', i < idx);
        });
        if (this.counter) this.counter.textContent = String(idx + 1).padStart(2, '0');
      }
      const vp = this.n > 1 ? clamp((p * this.n - 0.5) / (this.n - 1)) : p;
      if (this.viewer && this.viewer.setProgress) this.viewer.setProgress(vp);
    }
  }

  /* ---------- Vidéo incurvée ---------- */
  class CurvedVideo extends HTMLElement {
    connectedCallback() {
      this.video = $('video', this);
      this.toggle = $('[data-video-toggle]', this);
      if (this.video) {
        this.video.muted = true;
        this.video.playsInline = true;
        if (reduced) this.video.removeAttribute('autoplay');
        this.userPaused = reduced;
        this.io = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting && !this.userPaused) this.video.play().catch(() => {});
          else this.video.pause();
        }, { threshold: 0.25 });
        this.io.observe(this.video);
        this.video.addEventListener('play', () => this.sync());
        this.video.addEventListener('pause', () => this.sync());
      }
      this.toggle && this.toggle.addEventListener('click', () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.video.play().catch(() => {});
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      });
    }
    sync() {
      if (this.toggle) this.toggle.classList.toggle('is-paused', this.video.paused);
    }
    disconnectedCallback() {
      this.io && this.io.disconnect();
    }
  }

  /* ---------- Vidéo « en vrai » : lecture uniquement à l'écran ---------- */
  class RealVideo extends HTMLElement {
    connectedCallback() {
      const v = $('video', this);
      if (!v) return;
      v.muted = true;
      v.playsInline = true;
      if (reduced) {
        v.removeAttribute('autoplay');
        v.pause();
        return;
      }
      this.io = new IntersectionObserver((entries) => (entries[0].isIntersecting ? v.play().catch(() => {}) : v.pause()), { threshold: 0.2 });
      this.io.observe(v);
    }
    disconnectedCallback() {
      this.io && this.io.disconnect();
    }
  }

  /* ---------- CTA flottant (mobile) ---------- */
  class FloatingCta extends HTMLElement {
    connectedCallback() {
      const hero = document.getElementById(this.dataset.hero);
      if (!hero) return;
      this.state = new Map();
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => this.state.set(e.target, e.isIntersecting));
        const heroVisible = this.state.get(hero) !== false;
        const blocked = [...this.state.entries()].some(([el, v]) => el !== hero && v);
        const show = !heroVisible && !blocked && !document.querySelector('cart-drawer.is-open');
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', String(!show));
        const a = $('a', this);
        if (a) a.tabIndex = show ? 0 : -1;
      });
      this.io.observe(hero);
      $$('[data-product-form], .ftr, .ctab').forEach((el) => this.io.observe(el));
    }
    disconnectedCallback() {
      this.io && this.io.disconnect();
    }
  }

  /* ---------- Effets liés au défilement ---------- */
  const scrollFx = {
    items: new Map(),
    visible: new Set(),
    ticking: false,
    io: null,
    init() {
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.isIntersecting ? this.visible.add(e.target) : this.visible.delete(e.target)));
        this.request();
      }, { rootMargin: '200px 0px' });
      const onScroll = () => this.request();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    },
    add(el, fn) {
      this.items.set(el, fn);
      this.io.observe(el);
    },
    remove(el) {
      this.items.delete(el);
      this.visible.delete(el);
      this.io.unobserve(el);
    },
    request() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.visible.forEach((el) => {
          const fn = this.items.get(el);
          fn && fn();
        });
      });
    },
  };

  function fxProgress(el) {
    const r = el.getBoundingClientRect();
    const vh = window.innerHeight;
    const mode = el.dataset.scrollFx;
    if (mode === 'out') return clamp(-r.top / Math.max(1, r.height));
    if (mode === 'in') return clamp((vh - r.top) / (vh * 0.8));
    return clamp((vh - r.top) / (vh + r.height));
  }

  function initScrollFx(root = document) {
    if (reduced) return;
    $$('[data-scroll-fx]', root).forEach((el) => {
      if (scrollFx.items.has(el)) return;
      scrollFx.add(el, () => el.style.setProperty('--p', fxProgress(el).toFixed(4)));
    });
  }

  /* ---------- Apparition ---------- */
  let revealIO;
  function initReveal(root = document) {
    const els = $$('[data-reveal]:not(.is-in)', root);
    if (!document.documentElement.classList.contains('has-reveal') || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    revealIO =
      revealIO ||
      new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            revealIO.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((el) => revealIO.observe(el));
  }

  /* ---------- Inclinaison 3D au survol ---------- */
  function initTilt(root = document) {
    if (!finePointer || reduced || T.enableTilt === false) return;
    $$('[data-tilt]', root).forEach((el) => {
      if (el.dataset.tiltReady) return;
      el.dataset.tiltReady = '1';
      let raf;
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width;
        const y = (e.clientY - r.top) / r.height;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          el.style.transition = 'transform .12s linear, box-shadow .5s';
          el.style.transform = `perspective(900px) rotateX(${(0.5 - y) * 7}deg) rotateY(${(x - 0.5) * 9}deg) translateY(-4px)`;
          el.style.setProperty('--mx', `${x * 100}%`);
          el.style.setProperty('--my', `${y * 100}%`);
        });
      });
      el.addEventListener('pointerleave', () => {
        cancelAnimationFrame(raf);
        el.style.transition = '';
        el.style.transform = '';
      });
    });
  }

  /* ---------- Enregistrement ---------- */
  const define = (name, cls) => !customElements.get(name) && customElements.define(name, cls);
  scrollFx.init();
  define('sticky-header', StickyHeader);
  define('menu-drawer', MenuDrawer);
  define('announcement-rotator', AnnouncementRotator);
  define('cart-drawer', CartDrawer);
  define('qty-input', QtyInput);
  define('quick-add', QuickAdd);
  define('product-info', ProductInfo);
  define('variant-picker', VariantPicker);
  define('media-gallery', MediaGallery);
  define('sticky-atc', StickyAtc);
  define('delivery-estimate', DeliveryEstimate);
  define('product-recs', ProductRecs);
  define('pv-3d', Pv3d);
  define('story-3d', Story3d);
  define('curved-video', CurvedVideo);
  define('floating-cta', FloatingCta);
  define('real-video', RealVideo);

  initReveal();
  initScrollFx();
  initTilt();

  document.addEventListener('shopify:section:load', (e) => {
    initReveal(e.target);
    initScrollFx(e.target);
    initTilt(e.target);
  });

  window.PopearTheme = { Cart, formatMoney, toast };
})();
